import * as yup from "yup";

export const GB_IN_BYTES = 1073741824;
const MB_IN_BYTES = 1048576;

const MAX_INDIVIDUAL_VIDEO_SIZE = 300 * MB_IN_BYTES; // 300 MB
const MAX_TOTAL_VIDEO_SIZE = 900 * MB_IN_BYTES; // 900 MB
const MAX_LAZ_LAS_SIZE = 380 * MB_IN_BYTES; // 380 MB
const MAX_OTHER_FILE_SIZE = 1 * GB_IN_BYTES; // 1 GB

// Schema de validação do formulário de projeto
export const projectSchema = yup.object().shape({
  name: yup.string().required("O nome do projeto é obrigatório."),
  product: yup.string().required("A seleção de um produto é obrigatória."),
  date: yup.string().required("A data do projeto é obrigatória."),
  files: yup
    .array()
    .min(1, "É necessário enviar pelo menos um arquivo.")
    .test("file-validation", "Um ou mais arquivos são inválidos.", function(files) {
      if (!files || files.length === 0) return true;

      const { product } = this.parent;
      const { isValid } = validateFiles(files, product);
      return isValid;
    })
});

export const ALLOWED_EXTENSIONS = {
  filmagens: ["mp4", "mov", "avi", "mkv"],
  gemeo_digital: ["laz", "las"],
  tour_360: ["jpg", "jpeg", "png"],
  fotos: ["jpg", "jpeg", "png"],
  geoview: ["tif", "tiff"],
  // legados (caso algum projeto antigo ainda esteja selecionado)
  ortomosaico: ["tif", "tiff"],
  geotiff: ["tif", "tiff"], // alias legado
  bim: ["ifc", "icf", "ifczip", "zip"]
};

export const validateFiles = (files, product) => {
  const validExtensions = ALLOWED_EXTENSIONS[product] || [];

  // 1. Validação de extensão
  for (const file of files) {
    const extension = file.name
      .split(".")
      .pop()
      .toLowerCase();

    // Para `.zip` em BIM, exige que o arquivo seja de IFC (ex.: `*.ifc.zip`).
    if (product === "bim" && extension === "zip") {
      const lowerName = file.name.toLowerCase();
      const isIfcZip = lowerName.endsWith(".ifc.zip") || lowerName.endsWith(".icf.zip");
      if (!isIfcZip) {
        return {
          isValid: false,
          errorMessage: `O arquivo ${file.name} não parece ser um pacote IFC válido (.ifc.zip/.icf.zip) para o produto BIM.`
        };
      }
    }

    if (!validExtensions.includes(extension)) {
      return {
        isValid: false,
        errorMessage: `O arquivo ${
          file.name
        } possui extensão inválida para este tipo de projeto. Permitidos: ${validExtensions.join(
          ", "
        )}`
      };
    }
  }

  // 2. Validação de tamanho
  if (product === "filmagens") {
    let totalVideoSize = 0;
    for (const file of files) {
      if (file.size > MAX_INDIVIDUAL_VIDEO_SIZE) {
        return {
          isValid: false,
          errorMessage: `O vídeo ${file.name} excede o limite de 300MB.`
        };
      }
      totalVideoSize += file.size;
    }
    if (totalVideoSize > MAX_TOTAL_VIDEO_SIZE) {
      return {
        isValid: false,
        errorMessage: `O tamanho total dos vídeos excede o limite de 900MB.`
      };
    }
  } else {
    for (const file of files) {
      const extension = file.name
        .split(".")
        .pop()
        .toLowerCase();
      if ((extension === "laz" || extension === "las") && file.size > MAX_LAZ_LAS_SIZE) {
        return {
          isValid: false,
          errorMessage: `O arquivo ${file.name} excede o limite de 380MB.`
        };
      } else if (file.size > MAX_OTHER_FILE_SIZE) {
        return {
          isValid: false,
          errorMessage: `O arquivo ${file.name} excede o limite de 1GB.`
        };
      }
    }
  }

  return { isValid: true, errorMessage: null };
};

